/**
 * Cupones AetherLite — admin CRUD + validar/canjear (coach).
 * Espejo del router backend aetherlite_coupons.
 */
import { apiFetch } from "./client";

export type CouponKind = "discount" | "free_months";
export type DiscountType = "percent" | "fixed";

export interface Coupon {
  id: number;
  code: string;
  kind: CouponKind;
  discount_type: DiscountType | null;
  discount_value: number | null;
  free_months: number | null;
  free_tier: string | null;
  applies_to_tier: string | null;
  max_uses: number | null;
  used_count: number;
  per_user_once: boolean;
  expires_at: string | null;
  active: boolean;
  note: string | null;
  created_at: string | null;
}

export interface CouponInput {
  code: string;
  kind: CouponKind;
  discount_type?: DiscountType | null;
  discount_value?: number | null;
  free_months?: number | null;
  free_tier?: string | null;
  applies_to_tier?: string | null;
  max_uses?: number | null;
  per_user_once?: boolean;
  expires_at?: string | null;
  active?: boolean;
  note?: string | null;
}

export interface CouponValidation {
  valid: boolean;
  message: string;
  kind?: CouponKind;
  discount_type?: DiscountType | null;
  discount_value?: number | null;
  final_price_cop?: number | null;
  discount_cop?: number | null;
  free_months?: number | null;
  free_tier?: string | null;
}

// ---------- Admin ----------
export async function listCoupons(): Promise<Coupon[]> {
  return apiFetch<Coupon[]>("/aetherlite/admin/coupons");
}

export async function createCoupon(input: CouponInput): Promise<Coupon> {
  return apiFetch<Coupon>("/aetherlite/admin/coupons", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export async function updateCoupon(
  id: number,
  patch: Partial<Pick<Coupon, "active" | "max_uses" | "expires_at" | "note">>,
): Promise<Coupon> {
  return apiFetch<Coupon>(`/aetherlite/admin/coupons/${id}`, {
    method: "PATCH",
    body: JSON.stringify(patch),
  });
}

export async function deleteCoupon(id: number): Promise<void> {
  await apiFetch(`/aetherlite/admin/coupons/${id}`, { method: "DELETE" });
}

// ---------- Coach ----------
export async function validateCoupon(code: string, tier?: string): Promise<CouponValidation> {
  return apiFetch<CouponValidation>("/aetherlite/coupons/validate", {
    method: "POST",
    body: JSON.stringify({ code, tier }),
  });
}

export async function redeemCoupon(code: string): Promise<{ ok: boolean; tier: string; renews_at: string | null; free_months: number }> {
  return apiFetch("/aetherlite/coupons/redeem", {
    method: "POST",
    body: JSON.stringify({ code }),
  });
}
